// Food
import RestaurantsIcon from "../assets/icons/Restaurants.png";
import CafesIcon from "../assets/icons/Cafes.png";
import BakeriesIcon from "../assets/icons/Bakeries.png";
import StreetFoodIcon from "../assets/icons/StreetFood.png";
import JuiceIcon from "../assets/icons/Juice.png";
import SweetShopsIcon from "../assets/icons/SweetShops.png";
import IceCreamIcon from "../assets/icons/IceCream.png";
import CateringIcon from "../assets/icons/Catering.png";
import FoodDeliveryIcon from "../assets/icons/FoodDelivery.png";
import MessServiceIcon from "../assets/icons/MessService.png";

// Healthcare
import HospitalsIcon from "../assets/icons/Hospitals.png";
import ClinicsIcon from "../assets/icons/Clinics.png";
import DentalIcon from "../assets/icons/DentalClinic.png";
import EyeHopsital from "../assets/icons/EyeHospital.png";
import DermatologistsIcon from "../assets/icons/Dermatologists.png";
import DiagnosticLabsIcon from "../assets/icons/DiagnosticLabs.png";
import BloodBanksIcon from "../assets/icons/BloodBlanks.png";
import AmbulanceServicesIcon from "../assets/icons/Ambulance.png";
import PhysiotherapyCentresIcon from "../assets/icons/Physiotherapy.png";
import NursingServicesIcon from "../assets/icons/Nursing.png";
import VetHospitalsIcon from "../assets/icons/PetHospitals.png";
import MedicalShopsIcon from "../assets/icons/Shopping.png";

// Plumbers & Home Repair
import PlumbersIcon from "../assets/icons/Plumbarsubactegory.png";
import ElectriciansIcon from "../assets/icons/Electricians.png";
import CarpentersIcon from "../assets/icons/Carpenters.png";
import PaintersIcon from "../assets/icons/Painters.png";
import AcRepairIcon from "../assets/icons/AcRepair.png";
import FridgeRepairIcon from "../assets/icons/Fridge.png";
import WashingMachineRepairIcon from "../assets/icons/WashingMachine.png";
import WaterPurifierIcon from "../assets/icons/WaterPurify.png";
import GasStoveRepairIcon from "../assets/icons/GasStoveRepair.png";
import SolarPanelIcon from "../assets/icons/SloarPanel.png";

// Beauty & Wellness
import FitnessCentresIcon from "../assets/icons/Fitness.png";
import YogaCentresIcon from "../assets/icons/YogaCentres.png";
import SkinClinicsIcon from "../assets/icons/SkinClinic.png";
import TattooStudiosIcon from "../assets/icons/TattoStudios.png";
import BeautyIcon from "../assets/icons/BeautyIcon.png";
import SalonsIcon from "../assets/icons/Salone.png";
import SpaMassageCentresIcon from "../assets/icons/SpaMassage.png";
import MakeupArtistsIcon from "../assets/icons/MakeupArtist.png";
import MehendiArtistsIcon from "../assets/icons/MehendiArtist.png";

// Real Estate
import InteriorIcon from "../assets/icons/Interior.png";
import PropertyIcon from "../assets/icons/propertyDealers.png";
import RentIcon from "../assets/icons/Rent.png";
import BuildersIcon from "../assets/icons/BuildersDevelopers.png";
import ConstructionIcon from "../assets/icons/ConstructionContractors.png";

// Shopping
import ShoeStore from "../assets/icons/ShoeShop.png";
import MobileStore from "../assets/icons/MobileStores.png";
import SuperMarket from "../assets/icons/Supermarkets.png";
import ClothsStore from "../assets/icons/ClothingStores.png";
import ElectronicsStore from "../assets/icons/ElectronicsShops.png";
import FurnitureStore from "../assets/icons/FurniturStores.png";
import JewelryStore from "../assets/icons/JewelleryStores.png";
import Stationary from "../assets/icons/StationaryShops.png";
import GiftShop from "../assets/icons/GiftShop.png";
import OpticalShopIcon from "../assets/icons/OpticalShop.png";

// Education
import DrivingSchool from "../assets/icons/DrivingSchool.png";
import MusicalInstitute from "../assets/icons/MusicDanceClasses.png";
import College from "../assets/icons/Colleges.png";
import Tution from "../assets/icons/TuitionTeachers.png";
import SpokenEnglish from "../assets/icons/SpokenEnglishClasses.png";
import SkillDevelopment from "../assets/icons/SkillDevelopmentCentres.png";
import ComputerTraining from "../assets/icons/ComputerrainingInstitutes.png";
import School from "../assets/icons/Schools.png";
import Coaching from "../assets/icons/CoachingCentre.png";

// Automotive
import CarRepair from "../assets/icons/CarRepair.png";
import BikeRepair from "../assets/icons/BikeRepair.png";
import CarWash from "../assets/icons/CarWash.png";
import BikeWash from "../assets/icons/BikeWash.png";
import Automobile from "../assets/icons/Automobile.png";
import Towing from "../assets/icons/Towing.png";

// Home Services
import WaterCanService from "../assets/icons/WaterCanSupply.png";
import MaidService from "../assets/icons/MaidServices.png";
import Cook from "../assets/icons/CookServices.png";
import ElderCare from "../assets/icons/ElderlyCare.png";
import LaundaryService from "../assets/icons/LaundryServices.png";
import HouseKeeping from "../assets/icons/HouseKeeping.png";
import BabySitters from "../assets/icons/BabySitters.png";

// Business & Professional
import ChartedAccountant from "../assets/icons/CharteredAccountant.png";
import Lawyer from "../assets/icons/Lawyer.png";
import Notary from "../assets/icons/Notary.png";
import Insurance from "../assets/icons/InsuranceAgents.png";
import MarketingAgency from "../assets/icons/MarketingAgencies.png";
import PrintingPress from "../assets/icons/PrintingPress.png";
import PlublishingHouse from "../assets/icons/PlublishingHouse.png";
import EventPlanner from "../assets/icons/EventPlanners.png";
import PlacementConsultancy from "../assets/icons/PlacementServices.png";
import Regristrtaion from "../assets/icons/RegistrationConsultants.png";

// IT & Technology
import MobileRepair from "../assets/icons/MobileRepair.png";
import CCTV from "../assets/icons/CCTVInstallation.png";
import ComputerRepair from "../assets/icons/ComputerRepair.png";
import SoftwareService from "../assets/icons/SoftwareServices.png";
import WebsiteDevelopment from "../assets/icons/WebsiteDevelopment.png";
import InternetWebsite from "../assets/icons/InternetWebsiteDesigners.png";
import GraphicDesign from "../assets/icons/GraphicDesigners.png";
import DegitalMarketing from "../assets/icons/DigitalMarketing.png";

// Pet Services
import PetShops from "../assets/icons/PetShops.png";
import PetGrooming from "../assets/icons/PetGrooming.png";
import PetTraining from "../assets/icons/PetTraining.png";
import PetClinics from "../assets/icons/PetClinics.png";

// Party & Events
import Mandap from "../assets/icons/MandapDecorations.png";
import DJ from "../assets/icons/DJServices.png";
import PartyDecortation from "../assets/icons/PartyDecorations.png";

// Industrial
import Transport from "../assets/icons/Transporters.png";
import WaterTankCleaning from "../assets/icons/WaterTankCleaning.png";
import BoreWell from "../assets/icons/BorewellServices.png";
import MachineRepair from "../assets/icons/MachineRepair.png";
import Scrap from "../assets/icons/ScrapDealers.png";
import Fabricators from "../assets/icons/Fabricators.png";

// Sports & Recreation
import Stadium from "../assets/icons/Stadiums.png";
import IndorePlayarea from "../assets/icons/IndoorPlayAreas.png";
import SportsClub from "../assets/icons/SportsClubs.png";

// Courier & Logistics
import Courier from "../assets/icons/CourierOffices.png";
import Parcel from "../assets/icons/ParcelServices.png";
import Movers from "../assets/icons/MoversAndPackers.png";

// Corporate
import BackgroundVerification from "../assets/icons/BackgroundVerification.png";
import DocumentCourier from "../assets/icons/DocumentCourier.png";
import OfficeLeaning from "../assets/icons/OfficeCleaning.png";

// Daily Wages
import LoadingWorkers from "../assets/icons/Loading.png";
import GardenWorkers from "../assets/icons/GardenWorkers.png";
import CleaningWorkers from "../assets/icons/CleaningHelpers.png";
import Washmen from "../assets/icons/Watchmen.png";
import ConstructionLabours from "../assets/icons/ConstrucationLabor.png";

// Agriculture
import WeddingPlanners from "../assets/icons/WeddingPlanners.png";
import Fertilizer from "../assets/icons/FertilizerShops.png";
import Tractor from "../assets/icons/TractorRental.png";
import SeedsShop from "../assets/icons/SeedsShops.png";
import WaterPumpRepair from "../assets/icons/WaterPumpRepai.png";
import FarmingTools from "../assets/icons/FarmingTools.png";

// Wedding & Art
import FlowerDecoration from "../assets/icons/FlowerDecoration.png";
import WallMurals from "../assets/icons/WallMurals.png";

// ─────────────────────────────────────────────────────────────────────────────
// Travel & Accommodation (categoryId: 4)
// These PNG files don't exist yet — reusing closest available icons.
// ⚠️  Replace with proper icons once added to /assets/icons/
// ─────────────────────────────────────────────────────────────────────────────
const LodgeIcon        = HouseKeeping;        // placeholder → add Lodge.png
const BusTicketIcon    = Transport;           // placeholder → add BusTicket.png
const TrainTicketIcon  = Transport;           // placeholder → add TrainTicket.png
const BikeRentalIcon   = BikeRepair;          // placeholder → add BikeRental.png
const TaxiServiceIcon  = Automobile;          // placeholder → add TaxiService.png
const TravelAgencyIcon = EventPlanner;        // placeholder → add TravelAgency.png
const GuestHouseIcon   = HouseKeeping;        // placeholder → add GuestHouse.png
const ResortsIcon      = SpaMassageCentresIcon; // placeholder → add Resorts.png
const HotelIcon        = HospitalsIcon;       // placeholder → add Hotel.png

// 👇 export map — keys must match item.name values in subcategories.json
export const SUBCATEGORY_ICONS: Record<string, string> = {

    // ── Food (categoryId: 1) ──────────────────────────────────────────────
    "Restaurants":          RestaurantsIcon,
    "Cafes":                CafesIcon,
    "Bakeries":             BakeriesIcon,
    "Street Food":          StreetFoodIcon,
    "Juice Shops":          JuiceIcon,
    "Sweet Shops":          SweetShopsIcon,
    "Ice Cream Parlours":   IceCreamIcon,
    "Catering Services":    CateringIcon,
    "Food Delivery":        FoodDeliveryIcon,
    "Mess Services":        MessServiceIcon,

    // ── Healthcare (categoryId: 2) ────────────────────────────────────────
    "Hospitals":                HospitalsIcon,
    "Clinics":                  ClinicsIcon,
    "Dental Clinics":           DentalIcon,
    "Eye Hospitals":            EyeHopsital,
    "Dermatologists":           DermatologistsIcon,
    "Diagnostic Labs":          DiagnosticLabsIcon,
    "Blood Banks":              BloodBanksIcon,
    "Ambulance Services":       AmbulanceServicesIcon,
    "Physiotherapy Centres":    PhysiotherapyCentresIcon,
    "Nursing Services":         NursingServicesIcon,
    "Vet Hospitals":            VetHospitalsIcon,
    "Medical Shops":            MedicalShopsIcon,

    // ── Plumbers & Home Repair (categoryId: 3) ───────────────────────────
    "Plumbers":                 PlumbersIcon,
    "Electricians":             ElectriciansIcon,
    "Carpenters":               CarpentersIcon,
    "Painters":                 PaintersIcon,
    "AC Repair":                AcRepairIcon,
    "Fridge Repair":            FridgeRepairIcon,
    "Washing Machine Repair":   WashingMachineRepairIcon,
    "Water Purifier Service":   WaterPurifierIcon,
    "Gas Stove Repair":         GasStoveRepairIcon,
    "Solar Panel Installation": SolarPanelIcon,

    // ── Travel & Accommodation (categoryId: 4) ───────────────────────────
    "Hotels":               HotelIcon,
    "Hotel":                HotelIcon,
    "Resorts":              ResortsIcon,
    "Lodges":               LodgeIcon,
    "Lodge":                LodgeIcon,
    "Guest Houses":         GuestHouseIcon,
    "Guest House":          GuestHouseIcon,
    "Travel Agencies":      TravelAgencyIcon,
    "Travel Agency":        TravelAgencyIcon,
    "Taxi Services":        TaxiServiceIcon,
    "Taxi Service":         TaxiServiceIcon,
    "Vehicle Rentals":      BikeRentalIcon,
    "Bike Rental":          BikeRentalIcon,
    "Bus Ticket Booking":   BusTicketIcon,
    "Bus Ticket":           BusTicketIcon,
    "Train Ticket Booking": TrainTicketIcon,
    "Train Ticket":         TrainTicketIcon,

    // ── Beauty & Wellness (categoryId: 5) ────────────────────────────────
    "Beauty Parlours":      BeautyIcon,
    "Salons":               SalonsIcon,
    "Spa & Massage Centres":SpaMassageCentresIcon,
    "Makeup Artists":       MakeupArtistsIcon,
    "Mehendi Artists":      MehendiArtistsIcon,
    "Fitness Centres":      FitnessCentresIcon,
    "Yoga Centres":         YogaCentresIcon,
    "Skin Clinics":         SkinClinicsIcon,
    "Tattoo Studios":       TattooStudiosIcon,

    // ── Real Estate (categoryId: 6) ───────────────────────────────────────
    "Property Dealers":         PropertyIcon,
    "Rent Lease Listings":      RentIcon,
    "Builders Developers":      BuildersIcon,
    "Interior Designers":       InteriorIcon,
    "Construction Contractors": ConstructionIcon,

    // ── Shopping & Retail (categoryId: 7) ────────────────────────────────
    "Supermarkets":     SuperMarket,
    "Clothing Stores":  ClothsStore,
    "Shoe Shops":       ShoeStore,
    "Mobile Stores":    MobileStore,
    "Electronics Shops":ElectronicsStore,
    "Furniture Stores": FurnitureStore,
    "Jewellery Stores": JewelryStore,
    "Stationery Shops": Stationary,
    "Gift Shops":       GiftShop,
    "Optical Shops":    OpticalShopIcon,

    // ── Education & Training (categoryId: 8) ─────────────────────────────
    "Schools":                      School,
    "Colleges":                     College,
    "Coaching Centres":             Coaching,
    "Tuition Teachers":             Tution,
    "Computer Training Institutes": ComputerTraining,
    "Music & Dance Classes":        MusicalInstitute,
    "Spoken English Classes":       SpokenEnglish,
    "Driving Schools":              DrivingSchool,
    "Skill Development Centres":    SkillDevelopment,

    // ── Automotive (categoryId: 9) ────────────────────────────────────────
    "Car Repair ":              CarRepair,   // ⚠️ trailing space kept to match JSON
    "Car Repair":               CarRepair,
    "Bike Repair":              BikeRepair,
    "Car Wash":                 CarWash,
    "Bike Wash":                BikeWash,
    "Automobile Spare Parts":   Automobile,
    "Towing Services":          Towing,

    // ── Home & Personal Services (categoryId: 10) ─────────────────────────
    "Maid Services":            MaidService,
    "Cook Services":            Cook,
    "Babysitters":              BabySitters,
    "Elderly Care":             ElderCare,
    "Laundry Services":         LaundaryService,
    "House Keeping Services":   HouseKeeping,
    "Water Can Supply":         WaterCanService,

    // ── Business & Professional Services (categoryId: 11) ─────────────────
    "Chartered Accountant":             ChartedAccountant,
    "Lawyers":                          Lawyer,
    "Notary":                           Notary,
    "Insurance Agents":                 Insurance,
    "Marketing Agencies":               MarketingAgency,
    "Printing & Xerox Shops":           PrintingPress,
    "Printing & Publishing Services":   PlublishingHouse,
    "Event Planners":                   EventPlanner,
    "Placement Services":               PlacementConsultancy,
    "Registration Consultants":         Regristrtaion,

    // ── IT & Technology (categoryId: 12) ──────────────────────────────────
    "Mobile Repair":                MobileRepair,
    "Computer & Laptop Repair":     ComputerRepair,
    "CCTV Installation":            CCTV,
    "Software Services":            SoftwareService,
    "Website Development":          WebsiteDevelopment,
    "Internet Website Designers":   InternetWebsite,
    "Digital Marketing":            DegitalMarketing,
    "Graphic Designers":            GraphicDesign,

    // ── Pet Services (categoryId: 13) ─────────────────────────────────────
    "Pet Shops":    PetShops,
    "Pet Grooming": PetGrooming,
    "Pet Training": PetTraining,
    "Pet Clinics":  PetClinics,

    // ── Party & Event Services (categoryId: 14) ───────────────────────────
    "DJ Services":       DJ,
    "Party Decorations": PartyDecortation,
    "Mandap Decorations":Mandap,

    // ── Industrial Services (categoryId: 15) ──────────────────────────────
    "Transporters":         Transport,
    "Water Tank Cleaning":  WaterTankCleaning,
    "Borewell Services":    BoreWell,
    "Fabricators":          Fabricators,
    "Machine Repair":       MachineRepair,
    "Scrap Dealers":        Scrap,

    // ── Courier & Logistics (categoryId: 16) ──────────────────────────────
    "Courier offices":  Courier,
    "Parcel services":  Parcel,
    "Packers":          Movers,

    // ── Sports & Recreation (categoryId: 17) ──────────────────────────────
    "Gyms":             FitnessCentresIcon,
    "Sports Clubs":     SportsClub,
    "Indoor Play Areas":IndorePlayarea,
    "Stadiums":         Stadium,

    // ── Daily Wages (categoryId: 18) ───────────────────────────────────────
    "Construction Labor":   ConstructionLabours,
    "Loading Workers":      LoadingWorkers,
    "Cleaning Helpers":     CleaningWorkers,
    "Watchmen":             Washmen,

    // ── Agriculture (categoryId: 19) ───────────────────────────────────────
    "Fertilizer Shops":     Fertilizer,
    "Tractor Rental":       Tractor,
    "Seeds Shops":          SeedsShop,
    "Farming Tools":        FarmingTools,
    "Veterinary Doctors":   VetHospitalsIcon,
    "Water Pump Repair":    WaterPumpRepair,

    // ── Corporate (categoryId: 20) ─────────────────────────────────────────
    "Background Verification":  BackgroundVerification,
    "Document Courier":         DocumentCourier,
    "Office Cleaning":          OfficeLeaning,

    // ── Art & Craft (categoryId: 21) ───────────────────────────────────────
    "Painting Artists":         PaintersIcon,
    "Caricature Artists":       MakeupArtistsIcon,
    "Handmade Gift Designers":  GiftShop,
    "Wall Murals":              WallMurals,
    "Craft Training":           SkillDevelopment,

    // ── Wedding Services (categoryId: 22) ─────────────────────────────────
    "Wedding Planners":         WeddingPlanners,
    "Poojari":                  FlowerDecoration,
    "Music Team":               FlowerDecoration,
    "Flower Decoration":        FlowerDecoration,
    "Sangeet Choreographers":   FlowerDecoration,
};